// extracted by mini-css-extract-plugin
export default {"productGallery":"lK-z","inQuickShop":"mK-z"};